import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { PartnerFeatureEnum } from "@/__generated__/types";

interface PermissionsErrorProps {
  type: "feature" | "permission";
  feature: PartnerFeatureEnum | null;
}

export const PermissionsError = ({ type, feature }: PermissionsErrorProps) => {
  const { t } = useTranslation();

  const getFeatureLabel = (featureEnum: PartnerFeatureEnum | null): string => {
    if (!featureEnum) return "";

    switch (featureEnum) {
      case PartnerFeatureEnum.BulkMessaging:
        return t("global.features.bulkMessaging");
      case PartnerFeatureEnum.Games:
        return t("global.features.automatedGames");
      case PartnerFeatureEnum.Rise:
        return t("global.features.RISE");
      default:
        return String(featureEnum).toLowerCase();
    }
  };

  const featureLabel = getFeatureLabel(feature);

  return (
    <div className="flex h-full items-center justify-center py-12">
      <div className="text-center">
        <h2 className="mb-3 text-2xl font-medium text-foreground">
          {type === "feature"
            ? t("upgrade.features.title", {
                feature: featureLabel,
              })
            : t("upgrade.permission.title")}
        </h2>
        <div className="mb-8 text-sm text-muted-foreground">
          {type === "feature" ? (
            <Trans
              i18nKey="upgrade.features.message"
              values={{ feature: featureLabel }}
              components={{
                supportLink: (
                  <a
                    href="mailto:support@zeemee.com"
                    className="font-medium text-foreground underline hover:no-underline"
                  />
                ),
              }}
            />
          ) : (
            <Trans
              i18nKey="upgrade.permission.message"
              components={{
                supportLink: (
                  <a
                    href="mailto:support@zeemee.com"
                    className="font-medium text-foreground underline hover:no-underline"
                  />
                ),
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};
